<mat-card class="container">
  <h3>Order Confirmation</h3>
  <p>Thank you for submitting your order!</p>
  <button mat-raised-button *ngIf="user" routerLink="/account/orders">View My Orders</button>
</mat-card>
